class TaoDropzone {
	constructor( labelEl, inputEl, options = {} ) {
		this.label = labelEl;
		this.input = inputEl;

		this.options = options;
		this.multiple = inputEl.getAttribute( 'multiple' ) ? true : false;

		this.setupEvents();
	}

	setupEvents = () => {
		const dropzone = this.label;

		[ 'drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop' ].forEach( ( eventName ) => {
			dropzone.addEventListener( eventName, ( ev ) => this.stopDefaultEvents( ev ) );
		} );

		dropzone.addEventListener( 'dragover', () => this.onDragOver(), false );
		dropzone.addEventListener( 'dragleave', () => this.onDragLeave(), false );

		dropzone.addEventListener( 'drop', ( ev ) => this.addFiles( ev.dataTransfer.files ), false );

		if ( 'LABEL' !== dropzone.nodeName ) {
			dropzone.addEventListener( 'click', () => this.openDialog() );
		}
	};

	stopDefaultEvents = ( ev ) => {
		ev.preventDefault();
		ev.stopPropagation();
	};

	onDragOver = () => {
		this.label.classList.add( 'dropzone-dragging', this.options.dragClass ?? null );
	};

	onDragLeave = () => {
		this.label.classList.remove( 'dropzone-dragging', this.options.dragClass ?? null );
	};

	addFiles = ( files ) => {
		const dataTransfer = new DataTransfer();

		// Trigger Dragleave on Drop.
		this.onDragLeave();

		Array.prototype.forEach.call( files, ( file ) => {
			dataTransfer.items.add( file );
			if ( ! this.multiple ) {
				return false;
			}
		} );

		const filesToBeAdded = dataTransfer.files;
		this.input.files = filesToBeAdded;
		this.input.dispatchEvent( new Event( 'change' ) );
	};

	openDialog = () => {
		this.input.click();
	};
}

export default TaoDropzone;
